'use strict';

var _ = require('lodash');
var DemandTransparencyUntruncatedMdAllGridTransformerFactory = function DemandTransparencyUntruncatedMdAllGridTransformerFactory(DataTransformer, momentService) {
  function DemandTransparencyUntruncatedMdAllGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-untruncated-md-mode';
    this.targetType = 'demand-transparency-all-data';
    this.priority = 1;
  }
  DemandTransparencyUntruncatedMdAllGridTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyUntruncatedMdAllGridTransformer.constructor = DemandTransparencyUntruncatedMdAllGridTransformer;
  DemandTransparencyUntruncatedMdAllGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyUntruncatedMdAllGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  DemandTransparencyUntruncatedMdAllGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DemandTransparencyUntruncatedMdAllGridTransformer.prototype.transform = function (data) {
    if (data.domain.results === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    var results = [];
    _.forEach(data.domain.results, function (d) {
      var market = d.origin + '-' + d.destination;
      var daysToDepartures = d.daysToDepartures;
      for (var i = 0, length = daysToDepartures.length; i < length; i++) {
        var dtd = daysToDepartures[i];
        var dataDimObj = dtd.untruncatedResHold;
        var momentDepartureDate = memoizedMomentOfDate(d.departureDate, momentService.FIELD.DEPARTURE_DATE);
        results.push({
          market: market,
          season: d.season,
          seasonOverride: d.seasonOverride,
          significantPOS: d.significantPOS,
          classGroupName: d.classGroupName,
          departureDate: momentDepartureDate,
          dtd: dtd.daysToDeparture,
          totalBookings: dataDimObj.reservationHoldingsTotal,
          grpBookings: dataDimObj.reservationHoldingsGroup,
          idvBookings: dataDimObj.reservationHoldingsIdv,
          untruncatedBookings: dataDimObj.untruncatedReservationHoldings,
          remainingDemand: dataDimObj.remainingUntruncatedReservationHoldings
        });
      }
    });
    return results;
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return DemandTransparencyUntruncatedMdAllGridTransformer;
};
DemandTransparencyUntruncatedMdAllGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandTransparencyUntruncatedMdAllGridTransformerFactory;